<template>
  <v-container fluid>
    <v-row justify="start" class="career-page">
      <v-col>
        <input-block
          :modules="preview"
          title="Превью"
        />
        <input-block
          :modules="notes"
          title="Примечания"
          :options="{ tabs: true }"
        />
      </v-col>
      <v-col>

        <input-block
          :modules="main"
          title="Основной текст"
          :options="{ tabs: true }"
        />
        <vacancies />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import InputBlock from "../InputBlock/InputBlock";
import Vacancies from "./Vacancies";

export default {
  name: "CareerPage",
  components: {Vacancies, InputBlock },
  data() {
    return {
      preview: {
        career: {
          image: {
            type: "image",
            langs: ["all"],
            hint: "1440 × 400 px"
          },
        }
      },
      main: {
        career: {
          main: {
            type: "textHtml",
            langs: ["ru", "kk", "en"],
            toolbar: [
              [{ header: [false, 2] }],
              ["bold", "italic", "underline"],
              [{ list: "ordered" }, { list: "bullet" }],
              ["link"]
            ],
            label: "",
            maxHeight: 500
          },
        }
      },
      notes: {
        career: {
          subNote: {
            type: "textHtml",
            langs: ["ru", "kk", "en"],
            toolbar: [
              ["bold", "italic", "underline"],
              ["link"]
            ],
            label: "Подпись ниже вакансий",
            maxHeight: 200
          },
          subheader: {
            type: "subheader",
            langs: ["ru", "kk", "en"],
            label: "Важная информация"
          },
          important_title: {
            type: "string",
            langs: ["ru", "kk", "en"],
            label: "Заголовок"
          },
          important: {
            type: "textHtml",
            langs: ["ru", "kk", "en"],
            label: "",
            toolbar: [
              ["bold", "italic", "underline"],
              ["link"]
            ],
            maxHeight: 300
          }
        }
      }
    };
  }
};
</script>
<style lang="scss">
.career-page {
  align-items: flex-start;
  >.col {
    min-width: 400px;
    flex: 1;
  }
  .ql-editor ol,
  .ql-editor ul{
    padding-left: 0;
  }
}
</style>
